import { createContext, useEffect, useContext, useReducer } from 'react';

import { pcServiceUrl } from '../config';

const DealersContext = createContext();

const initialState = { dealers: null, isLoading: true, error: null };

function reducer(state, action) {
  switch (action.type) {
    case 'fetch':
      return { ...state, isLoading: true, error: null };
    case 'success':
      return { dealers: action.payload, isLoading: false, error: null };
    case 'error':
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
}

function DealersProvider({ children }) {
  const [{ dealers, isLoading, error }, dispatch] = useReducer(
    reducer,
    initialState
  );

  useEffect(function () {
    const controller = new AbortController();

    async function fetchDealers() {
      try {
        dispatch({ type: 'fetch' });

        const res = await fetch(`${pcServiceUrl}/api/v1/dealer`, {
          signal: controller.signal,
          method: 'GET',
        });

        if (!res.ok) {
          dispatch({ type: 'error', payload: 'Failed to fetch dealers' });
          if (res.status === 404) throw new Error('Dealers not found');
          throw new Error('Something went wrong with fetching the dealers');
        }

        let data = await res.json();
        //console.log('DealersProvider(): data', data);

        let dealers = data.dealers;

        dispatch({ type: 'success', payload: dealers });
      } catch (err) {
        console.log(err.message);
        dispatch({ type: 'error', payload: err.message });
      }
    }

    fetchDealers();

    return function () {
      controller.abort();
    };
  }, []);

  return (
    <DealersContext.Provider
      value={{
        dealers,
        isLoading,
        error,
      }}
    >
      {children}
    </DealersContext.Provider>
  );
}

function useDealers() {
  const context = useContext(DealersContext);
  if (context === undefined)
    throw new Error('DealersContext was used outside the DealersProvider');
  return context;
}

export { DealersProvider, useDealers };
